import { parseTemplate, TemplateError } from "./template.ts";
import { type ThemeVersionData, ThemeVersionDataSchema } from "./tokens.ts";

const REMOTE_IN_CSS = /url\(\s*['"]?\s*(?:(?:https?|ftp|file):|\/\/)/i;
const REMOTE_IN_HTML = /(?:src|href)\s*=\s*["']?\s*(?:https?|ftp|file):/i;

function checkCss(path: string, css: string, errors: string[]): void {
  if (/<\/style/i.test(css)) errors.push(`${path}: must not contain "</style"`);
  if (/<!--/.test(css)) errors.push(`${path}: must not contain "<!--"`);
  if (/@import/i.test(css)) errors.push(`${path}: @import is not allowed`);
  if (REMOTE_IN_CSS.test(css)) errors.push(`${path}: remote or file URLs are not allowed`);
}

export function validateThemeVersion(
  data: unknown,
): { ok: true; data: ThemeVersionData } | { ok: false; errors: string[] } {
  const parsed = ThemeVersionDataSchema.safeParse(data);
  if (!parsed.success) {
    return {
      ok: false,
      errors: parsed.error.issues.map((i) => `${i.path.map(String).join(".") || "(root)"}: ${i.message}`),
    };
  }
  const errors: string[] = [];
  for (const [key, layout] of Object.entries(parsed.data.layouts)) {
    for (const part of ["cover", "titleBlock", "header", "footer"] as const) {
      const tpl = layout[part];
      if (tpl === undefined) continue;
      const path = `layouts.${key}.${part}`;
      try {
        parseTemplate(tpl);
      } catch (e) {
        if (!(e instanceof TemplateError)) throw e;
        errors.push(`${path}: ${e.message}`);
      }
      if (REMOTE_IN_HTML.test(tpl)) errors.push(`${path}: remote or file URLs are not allowed`);
    }
    checkCss(`layouts.${key}.css`, layout.css, errors);
  }
  checkCss("advancedCss", parsed.data.advancedCss, errors);
  return errors.length ? { ok: false, errors } : { ok: true, data: parsed.data };
}
